/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';
import { addUniqueById } from 'shared/lib/addUniqueById';

const initialState_container = [
    {
        id: '',
        il_ocean_export_hbl_id: '',
        cntr_number: '',
        seal_number: '',
        volume: '',
        il_trade_partner_id: '',
        delivery_order: '',
        deliver_order_link: '',
        pierpass: '',
        stages: '',
        stages_date: null,
    },
];

const oexContainerUpdateSlice = createSlice({
    name: 'oexContainerUpdateForm',
    initialState: initialState_container,
    reducers: {
        setContainerFormData: (state, action) => {
            return action.payload;
        },
        addContainer: (state, action) => {
            addUniqueById(state, action.payload);
        },
        deleteContainer: (state, action) => {
            const idToDelete = action.payload;
            return state.filter((container) => container.id !== idToDelete);
        },
        setContainerUpdateData: (state, action) => {
            const { id, newData } = action.payload;
            return state.map((item) => {
                if (item.id === id) {
                    return { ...item, ...newData };
                }
                return item;
            });
        },
    },
});

export const { setContainerFormData, addContainer, deleteContainer, setContainerUpdateData } =
    oexContainerUpdateSlice.actions;
export default oexContainerUpdateSlice.reducer;
